// test392
(392 && 0);
